module.exports = __webpack_public_path__ + "img/thumbnails-10-music-player.4bbd883b.png";